var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-search-preview-wrap" }, [
    _c("div", { staticClass: "boss-search-preview" }, [
      _c(
        "div",
        { staticClass: "boss-layout boss-layout-vertical" },
        [
          _vm.isSearching
            ? [
                _c("div", {
                  staticClass: "loader-mini",
                  attrs: { "data-test": "loader" },
                }),
              ]
            : [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "boss-layout boss-layout-gap-small boss-layout-search-preview",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "boss-search-preview-result",
                          attrs: { "data-test": "hit-num" },
                        },
                        [
                          _vm.isError
                            ? [_vm._v("\n                −\n              ")]
                            : [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm._f("hitOmit")(_vm.hit.num)) +
                                    "\n              "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "boss-search-preview-text" }, [
                        _vm._v("\n              名\n            "),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm.isSearchable
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "boss-button boss-button-fill pega-button pega-min-width-100-percent",
                          attrs: {
                            disabled:
                              (_vm.isCheckedSaveSearch &&
                                _vm.isEmptySearchConditionName) ||
                              _vm.isError,
                            type: "button",
                            "data-test": "search-button",
                          },
                          on: { click: _vm.search },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "boss-button-before boss-icon-triangle",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "boss-button-text",
                              attrs: { "data-test": "search-button-text" },
                            },
                            [
                              _vm.searchConditionId
                                ? [
                                    _vm._v(
                                      "\n                保存して検索する\n              "
                                    ),
                                  ]
                                : _vm.isCheckedSaveSearch
                                ? [
                                    _vm._v(
                                      "\n                検索条件を保存して検索する\n              "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                検索する\n              "
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "boss-search-preview-alert",
                          attrs: { "data-test": "over-hit" },
                        },
                        [
                          _vm._v(
                            "\n            1000名以上ヒットしています。\n            "
                          ),
                          _c("br"),
                          _vm._v("条件を絞って下さい\n          "),
                        ]
                      ),
                ]),
              ],
          _vm._v(" "),
          _c("div", [
            _c("label", { staticClass: "pega-input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isCheckedSaveSearch,
                    expression: "isCheckedSaveSearch",
                  },
                ],
                staticClass: "boss-input-checkbox",
                attrs: {
                  type: "checkbox",
                  "data-test": "save-search-checkbox",
                },
                domProps: {
                  checked: Array.isArray(_vm.isCheckedSaveSearch)
                    ? _vm._i(_vm.isCheckedSaveSearch, null) > -1
                    : _vm.isCheckedSaveSearch,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.isCheckedSaveSearch,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.isCheckedSaveSearch = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.isCheckedSaveSearch = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.isCheckedSaveSearch = $$c
                    }
                  },
                },
              }),
              _vm._v("検索条件に名前を付けて保存する\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchConditionName,
                  expression: "searchConditionName",
                },
              ],
              staticClass: "boss-input boss-input-fill",
              class: {
                "is-invalid-input":
                  _vm.isCheckedSaveSearch && _vm.isEmptySearchConditionName,
              },
              attrs: {
                disabled: !_vm.isCheckedSaveSearch,
                type: "text",
                placeholder: "検索条件名を入力",
                "data-test": "save-search-condition-name",
              },
              domProps: { value: _vm.searchConditionName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchConditionName = $event.target.value
                },
              },
            }),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }